export { default } from './AuthorizationBanner';
